import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const Safety = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="80"
    viewBox="0 0 79 80"
    fill="none">
    <rect width="79" height="80" rx="39.5" fill="#3A3A3A" />
    <path
      d="M69.8656 15.9977L40.2406 6.12266C39.7469 5.87578 39.2531 5.87578 38.7594 6.12266L9.13438 15.9977C8.14688 16.2445 7.40625 17.232 7.40625 18.2195V30.5633C7.40625 46.857 15.0594 62.1633 28.1437 72.0383L38.0187 79.4445C39.0062 80.1852 39.9938 80.1852 40.9813 79.4445L50.8563 72.0383C63.9406 62.1633 71.5938 46.857 71.5938 30.5633V18.2195C71.5938 17.232 70.8531 16.2445 69.8656 15.9977ZM37.525 63.6445C37.0312 64.3852 36.2906 64.632 35.55 64.632C35.0562 64.632 34.5625 64.3852 34.0688 64.1383C23.4531 56.2383 17.2812 43.6477 17.2812 30.5633C17.2812 29.082 18.2688 28.0945 19.75 28.0945C21.2312 28.0945 22.2188 29.082 22.2188 30.5633C22.2188 42.1664 27.65 53.2758 37.0312 60.1883C38.0187 60.9289 38.2656 62.657 37.525 63.6445Z"
      fill="white"
    />
  </SvgIcon>
);

export default Safety;
